module.exports = web3dPluginAssembly;